export const FILTER_OPTIONS = {
  type: 'type',
  topic: 'topic',
  tag: 'tag',
};

export const FILTER_ARTICLE_TYPES = {
  ondernemersverhalen: 'Ondernemersverhalen',
  ondernemerstips: 'Ondernemerstips',
  sectorguide: 'Sectorinformatie',
  // podcast: 'Podcasts', // Podcast urls not working so removed from update 14.3.6
  talkshow: 'Talkshows',
  Webinar: 'Webinar',
};

export const FILTER_LABELS = {
  typeLabel: 'Filter op type',
  subjectLabel: 'Filter op onderwerp',
};
